/**
 * Who uploaded a document. Mirrors `api/src/constants/document.js` — the values
 * originate in OFMP and are surfaced on each document, and on a document group
 * (a group is homogeneous, so it carries its documents' value).
 */
export const DOCUMENT_UPLOADED_BY = {
  BUYER: 'BUYER',
  VENDOR: 'VENDOR',
} as const;
